import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { SetupTourGuideFormPage } from './setup-tour-guide-form.page';

const routes: Routes = [
  {
    path: '',
    component: SetupTourGuideFormPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SetupTourGuideFormPageRoutingModule {}
